import script from "./TemplateSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateSelect.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateSelect.vue?vue&type=style&index=0&id=427eed90&lang=scss"

const __exports__ = script;

export default __exports__